import { createContext } from 'react';

export type DisclosureVariant = 'base' | 'subtle';
export type DisclosureSize = 'small' | 'medium';

/** @internal */
export interface DisclosureContextValue {
  variant: DisclosureVariant;
  size: DisclosureSize;
}

/** @internal */
export const DisclosureContext = createContext<DisclosureContextValue | null>(null);
